import * as React from 'react';

import ProfileCard from 'components/cards/profile-card/ProfileCard';

import ProfileMainInformationFields from './fields/ProfileMainInformationFields';

import ProfileImage from '../../components/profile-image/ProfileImage';

import { __t, applyTranslations } from 'utils/language';

import './profile-main-information.scss';

applyTranslations(require('./profile-main-information.i18n.json'));

import type { InfluencerProfileForm } from 'types';

interface Props {
  profile: InfluencerProfileForm,
  hasError: boolean,
  isTalentAgencyManaged?: boolean,
  onChange: (profile: Partial<InfluencerProfileForm>) => void
}

const MSG_KEY = 'profile_main_information';

const ProfileMainInformation: React.FC<Props> = ({
  profile,
  hasError,
  isTalentAgencyManaged,
  onChange
}) => (
  <div className="profile-main-information">
    <div className="profile-main-information__title">
      {__t(`${MSG_KEY}.title`)}
    </div>
    <div className="profile-main-information__description">
      {__t(`${MSG_KEY}.description`)}
    </div>
    <ProfileCard
      classNameContents="profile-main-information__contents"
    >
      <ProfileImage
        profile={profile}
        onChange={onChange}
      />
      <ProfileMainInformationFields
        profile={profile}
        hasError={hasError}
        onChange={onChange}
        isTalentAgencyManaged={isTalentAgencyManaged}
      />
    </ProfileCard>
  </div>
);

export default ProfileMainInformation;
